<template>
  <div>
    <h1>{{ $t('views.yourReservations.title') }}</h1>
    <loading-container :state="state">

      <error-message class="my-3" i18nMessage="views.yourReservations.noReservations" v-if="tickets.length === 0" />
      <ul class="row list-unstyled mt-3 mx-auto p-inline-start-0" v-if="tickets.length > 0">
        <li v-for="(ticket, index) in tickets" :key="index" class="col-12 mb-2">
          <div class="d-flex row reservation-overview no-underline">
            <div class="col-12 col-md-3 p-2 px-4 bg-darker bg-hover-dark font-weight-bold d-flex align-items-center">
              {{ formatDay(ticket) }}<br>
              {{ formatTimeOnly(ticket) }}
            </div>
            <div class="col-12 col-md-9 d-flex align-items-center">
              <div class="saal-desc p-2">
                <h2 class="m-0">{{ ticket.roomName }}</h2>
                <p class="mb-1">{{ ticket.roomDescription }}</p>
              </div>
              <div class="ml-auto">
                <button-delete i18nMessage="common.ticketCancel" v-on:clicked="cancelTicket(ticket)" :iconOnly="true" class="btn-outline-icon-only btn-outline-icon-text-black" />
              </div>
            </div>
          </div>
        </li>
      </ul>

      <p v-if="hasRemainingTime()">{{ $tc('views.yourReservations.infoText', remainingMinutes()) }}</p>
      <link-arrow i18nMessage="common.addMoreReservations" to="/" v-if="tickets.length < maxReservations" />

      <div class="row mt-3">
          <div class="col-12 col-md-4 offset-md-4">
            <link-default to="/your-personal-data" i18nMessage="views.yourReservations.proceedToYourData" v-if="tickets.length > 0" class="btn btn-outline-brand1 w-100 link-to-outline-btn" />
          </div>
      </div>

      <button-panic class="btn-to-danger-link d-flex justify-content-end pr-3 mt-5" />
    </loading-container>

    <div class="col-12 d-flex justify-content-end mt-3 px-0">
      <link-faq />
    </div>

  </div>
</template>

<script lang="ts">
import ErrorMessage from '@/components/feedback/ErrorMessage.vue'
import ButtonDelete from '@/components/interaction/ButtonDelete.vue'
import LinkArrow from '@/components/interaction/LinkArrow.vue'
import LinkDefault from '@/components/interaction/LinkDefault.vue'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import config from '@/config/config'
import { Ticket } from '@/generated/openapi'
import LoadingMixin from '@/mixins/LoadingMixin'
import ShoppingCartTimerMixin from '@/mixins/ShoppingCartTimerMixin'
import { userService } from '@/services/userService'
import { formatTicketTime, formatTicketTimeDay, formatTicketTimeOnly } from '@/utils/formatUtils'
import { LoadingState } from '@/utils/loadingUtils'
import { defineComponent } from 'vue'
import ButtonPanic from '@/components/interaction/ButtonPanic.vue'
import LinkFaq from '@/components/interaction/LinkFaq.vue'


export default defineComponent({
  name: 'YourReservations',
  mixins: [
    LoadingMixin,
    ShoppingCartTimerMixin
  ],
  data() {
    return {
      maxReservations: config.maxReservations
    }
  },
  components: {
    LoadingContainer,
    LinkDefault,
    LinkArrow,
    ButtonDelete,
    ErrorMessage,
    ButtonPanic,
    LinkFaq
  },
  created() {
    userService.refreshShoppingCart()
    .then(this.handleSuccess)
    .catch(this.handleError)
  },
  computed: {
    tickets(): Ticket[] {
      return this.$store.state.transactionTickets
    }
  },
  methods: {
    formatStartTime(ticket: Ticket) {
      return formatTicketTime(ticket)
    },
    formatDay(ticket: Ticket){
      return formatTicketTimeDay(ticket)
    },
    formatTimeOnly(ticket: Ticket){
      return formatTicketTimeOnly(ticket);
    },
    cancelTicket(ticket: Ticket) {
      this.state = LoadingState.loading
      return userService.removeFromShoppingCart(ticket.id)
        .then(() => {
          return userService.refreshShoppingCart()
        }).then(() => {
          this.state = LoadingState.success
        }).catch(() => {
          this.state = LoadingState.error
        })
    }
  }
});
</script>
